import React from 'react';
import './AvatarBubbleSkeleton.css';

export default function AvatarBubbleSkeleton({ count = 10 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div className="bf-ava-skel-wrap" key={i}>
          <div className="bf-ava-skel-circle" />
          <div className="bf-ava-skel-name" />
        </div>
      ))}
    </>
  );
}
